/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConditionDTO
 */
export interface ConditionDTO {
    /**
     * 
     * @type {string}
     * @memberof ConditionDTO
     */
    attribute?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConditionDTO
     */
    values?: Array<string>;
}

export function ConditionDTOFromJSON(json: any): ConditionDTO {
    return ConditionDTOFromJSONTyped(json, false);
}

export function ConditionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attribute': !exists(json, 'attribute') ? undefined : json['attribute'],
        'values': !exists(json, 'values') ? undefined : json['values'],
    };
}

export function ConditionDTOToJSON(value?: ConditionDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attribute': value.attribute,
        'values': value.values,
    };
}

